import { useEffect, useState } from 'react'

// The target element is rendered by another part of the component tree, so it doesn't exist
// yet on the first render - it's looked up after mount instead of via a lazy useState initializer.
export const usePortalSlot = (elementId: string): Element | null => {
    const [slotElement, setSlotElement] = useState<Element | null>(null)

    useEffect(() => {
        setSlotElement(document.getElementById(elementId))
    }, [elementId])

    return slotElement
}
